export default function CheckFilled() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Automated migration to Biome
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <g id='chevron-right-filled'>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <path
          id='Vector'
          d='M9.99573 18.3259C14.5549 18.3259 18.3327 14.5554 18.3327 9.9962C18.3327 5.43702 14.5477 1.6665 9.98847 1.6665C5.43327 1.6665 1.66602 5.43702 1.66602 9.9962C1.66602 14.5554 5.44052 18.3259 9.99573 18.3259ZM8.09628 14.1736C7.86629 13.9403 7.87028 13.582 8.09227 13.3672L11.6352 10.0035L8.09227 6.64694C7.86302 6.43222 7.87028 6.06333 8.10352 5.83735C8.32153 5.63312 8.66613 5.64837 8.90188 5.86636L12.4902 9.26819C12.9196 9.66864 12.9164 10.3488 12.4902 10.7427L8.90188 14.1478C8.68788 14.3513 8.29648 14.3625 8.09628 14.1736Z'
          fill='#1F2647'
        />
      </g>
    </svg>
  );
}
